module.exports = __webpack_public_path__ + "fonts/AntykwaTorunskaMed-Italic.14c2a20c.ttf";